var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-search';
                    var viewUrl = 'sprite.svg#view-icon-search';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-search#icon-search';
                            viewUrl = 'sprite.svg?icon-search#view-icon-search';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };